import MetaMessage from './MetaMessage'
export default MetaMessage



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MetaMessage/index.js